import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { LoadingDialog } from '../../../../../_metronic/_partials/controls';

export function DeliveriesLoadingDialog() {
  const { isLoading } = useSelector(
    (state) => ({
      isLoading: state.deliveries ? state.deliveries.listLoading : false,
    }),
    shallowEqual
  );
  useEffect(() => {}, [isLoading]);
  return <LoadingDialog isLoading={isLoading} text='Уншиж байна ...' />;
}
